//  Copyright (c) 2021 First Foundry Inc. All rights reserved.

export const PATH = 'inventoryCategoryDetail'
export const SET_START_DATE = `${PATH}/SET_START_DATE`
export const SET_END_DATE = `${PATH}/SET_END_DATE`
export const OPEN_INVENTORY_CATEGORY_DETAIL_CSV_REPORT = `${PATH}/OPEN_INVENTORY_CATEGORY_DETAIL_CSV_REPORT`
